{
  "version": 1,
  "asset_id": "2785d609-78b0-4eb0-b952-dcad3c0830f6",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2785d609-78b0-4eb0-b952-dcad3c0830f6/hiatal-type-1-repair-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2785d609-78b0-4eb0-b952-dcad3c0830f6/hiatal-type-1-repair-es-480.webp",
  "original_filename": "hiatal-type-1-repair-es-480.webp",
  "size": 19904,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:52Z"
}
